<template>
  <div>
    <div ref="map" class="map"></div>
  </div>
</template>
<script>
import { isHeadless } from "@/helpers";
import "mapbox-gl-controls/theme.css";
import ZoomControl from "mapbox-gl-controls/lib/zoom";
import StylesControl from "mapbox-gl-controls/lib/styles";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

export default {
  data() {
    return {
      map: null,
      marker: null
    };
  },
  props: {
    center: {
      type: Array,
      required: true
    }
  },
  mounted() {
    if (isHeadless()) {
      return;
    }
    mapboxgl.accessToken = import.meta.env.VITE_APP_MAPBOX_TOKEN;
    this.map = new mapboxgl.Map({
      container: this.$refs.map,
      zoom: 15.5,
      center: this.center,
      pitch: 30,
      style: "mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y"
    });
    this.map.on("load", () => {
      this.map.addSource("mapbox-dem", {
        type: "raster-dem",
        url: "mapbox://mapbox.mapbox-terrain-dem-v1",
        tileSize: 512,
        maxzoom: 14
      });
      // add the DEM source as a terrain layer with exaggerated height
      this.map.setTerrain({ source: "mapbox-dem", exaggeration: 1.5 });

      // add a sky layer that will show when the map is highly pitched
      this.map.addLayer({
        id: "sky",
        type: "sky",
        paint: {
          "sky-type": "atmosphere",
          "sky-atmosphere-sun": [0.0, 0.0],
          "sky-atmosphere-sun-intensity": 15
        }
      });
      this.map.addControl(
        new StylesControl({
          styles: [
            {
              label: "Satellite",
              styleName: "Satellite",
              styleUrl:
                "mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y"
            },
            {
              label: "Streets",
              styleName: "Mapbox Streets",
              styleUrl: "mapbox://styles/mapbox/streets-v9"
            }
          ]
        }),
        "top-left"
      );
      this.map.addControl(new ZoomControl(), "top-right");
    });
    this.marker = new mapboxgl.Marker({
      draggable: true
    })
      .setLngLat(this.center)
      .addTo(this.map);

    this.marker.on("dragend", () => {
      const lngLat = this.marker.getLngLat();
      this.$router
        .push({
          name: "map",
          params: {
            latitude: `${lngLat.lat}`,
            longitude: `${lngLat.lng}`,
            lang: this.$i18n.locale === "en" ? null : this.$i18n.locale
          }
        })
        .catch(() => {});
    });
  },
  watch: {
    center() {
      this.marker.setLngLat(this.center);
      this.map.panTo(this.center);
    }
  },
  beforeUnmount() {
    this.map.remove();
  }
};
</script>
